import { render, staticRenderFns } from "./ProjectsPanelAllProjectsNavItem.vue?vue&type=template&id=07350bc2&"
import script from "./ProjectsPanelAllProjectsNavItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelAllProjectsNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports